import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { PageHeader, Tag } from 'antd';

import { pageSectionTitle } from '../util/Style';

import { AgGridReact } from 'ag-grid-react';

const height = window.innerHeight * .74;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};

const dueGetter = (params) => {
    return params.data.Total - params.data.PaidAmount;
};

const columnDefs = [
    { headerName: 'Document', field: 'docNumber'},
    { headerName: 'Bill', field: 'billAmount', type: 'numericColumn', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Received', field: 'received', type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Due', field: 'due', type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Bucket', field: 'bucket', type: 'numericColumn', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
]

class LabDetailsGrid extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    fetchSelectedLabDetails = () => {
        this.store.fetchSelectedLabDetails();
    }

    refreshGrid = () => {
        this.gridRef.current.api.redrawRows();
    }

    render() {
        const labName = this.store.selectedLab.labName;
        
        return (  
            <PageHeader style={{ paddingTop: 0 }} title={pageSectionTitle(labName)} onBack={() => this.store.clearSelectedLab()}>
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={this.store.selectedLabDetails}
                        columnDefs={columnDefs}
                        rowSelection={'single'}
                        onGridReady={this.fetchSelectedLabDetails}
                        rowHeight={25}
                    >
                    </AgGridReact>
                </div>
            </PageHeader>
        )
    }
}

export default observer(LabDetailsGrid)
